import { useEffect } from 'react'

import { useLazyGetExternalUserByIdQuery } from '../../../store/externalUser/externalUser'
import { useAppDispatch, useAppSelector } from '../../../store/hooks'
import { selectAccountId } from '../../../store/auth/authSlice'
import { useLazyGetMeQuery } from '../../../store/user/user'
import { resetEmailUsers, setCurrentUser, setEmailCurrentUserLoading } from '../../../store/emailHub/emailUsers'
import { resetNewEmail, setNewEmailContactLoading, setNewEmailRecipientContact, setNewEmailRelatedContact } from '../../../store/emailHub/newEmail'
import { useSearchParams } from 'react-router-dom'
import { hasClientRole } from '../NewEmail/utils'

export const NewEmailInitialization = () => {
  useInitializeCurrentUser()
  useInitializeContact()
  useCleanUpNewEmail()

  return null
}

const useInitializeCurrentUser = () => {
  const dispatch = useAppDispatch()

  const accountId = useAppSelector(selectAccountId)

  const [triggerGetMe] = useLazyGetMeQuery()

  useEffect(() => {
    const fetchMe = async () => {
      dispatch(setEmailCurrentUserLoading(true))
      try {
        const { data: currentUser } = await triggerGetMe({ accountId }, true)
        if (!currentUser) {
          return
        }
        dispatch(setCurrentUser(currentUser))
      } finally {
        dispatch(setEmailCurrentUserLoading(false))
      }
    }

    fetchMe()

    return () => {
      dispatch(resetEmailUsers())
    }
  }, [dispatch, accountId, triggerGetMe])
}

const useInitializeContact = () => {
  const dispatch = useAppDispatch()

  const accountId = useAppSelector(selectAccountId)

  const [searchParams] = useSearchParams()

  const [triggerGetContactById] = useLazyGetExternalUserByIdQuery()

  useEffect(() => {
    const fetchContact = async (contactId: string) => {
      dispatch(setNewEmailContactLoading(true))
      try {
        const { data: contactResponse } = await triggerGetContactById({ accountId, userId: contactId })
        if (!contactResponse?.data) {
          return
        }
        const { data: contact } = contactResponse

        dispatch(setNewEmailRecipientContact(contact))
        dispatch(setNewEmailRelatedContact(hasClientRole(contact) ? contact : null))
      } finally {
        dispatch(setNewEmailContactLoading(false))
      }
    }

    const contactId = searchParams.get('contactId')
    if (!contactId) {
      return
    }

    fetchContact(contactId)
  }, [dispatch, accountId, searchParams, triggerGetContactById])
}

const useCleanUpNewEmail = () => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    return () => {
      dispatch(resetNewEmail())
    }
  }, [dispatch])
}
